// "Did you mean ...@gmail.com?" (Nic 2026-10-20, Add a person). A typo in a
// big provider's domain (gmail.co, gmial.com, yahooo.com, outlok.com) is the
// most common bad email a rep types while someone spells it on the phone.
// A pattern can't catch it (.co is a real ending), so compare the domain to
// the providers veterans actually use and offer the close one. Exact
// matches, and real providers that look alike (mail.com, me.com), are left
// alone. The server separately refuses a domain that can't receive mail.

const PROVIDERS = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'icloud.com',
  'aol.com',
  'live.com',
  'msn.com',
  'comcast.net',
  'att.net',
  'sbcglobal.net',
  'verizon.net',
  'ymail.com',
  'protonmail.com',
  'bellsouth.net',
  'charter.net',
  'cox.net',
];
// Real domains that sit one or two letters from a provider: never "fixed".
// The country versions of the providers count too (branch QA 2026-10-21:
// yahoo.ca, live.ca and aim.com were offered a "fix").
const ALSO_REAL = new Set([
  'mail.com',
  'me.com',
  'mac.com',
  'gmx.com',
  'email.com',
  'proton.me',
  'att.com',
  'aim.com',
  'yahoo.ca',
  'yahoo.co.uk',
  'yahoo.co.in',
  'live.ca',
  'live.co.uk',
  'hotmail.ca',
  'hotmail.co.uk',
  'outlook.ca',
  'gmx.net',
  'gmx.de',
]);

// Edit distance, with a swap of two neighbors counting as one (gmial).
const distance = (a, b) => {
  const d = Array.from({ length: a.length + 1 }, (_, i) => [i, ...Array(b.length).fill(0)]);
  for (let j = 1; j <= b.length; j += 1) d[0][j] = j;
  for (let i = 1; i <= a.length; i += 1) {
    for (let j = 1; j <= b.length; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
  }
  return d[a.length][b.length];
};

/** The corrected address, or null when it looks right. */
export const suggestEmail = (email) => {
  const value = String(email || '').trim();
  const at = value.lastIndexOf('@');
  if (at < 1) return null;
  const local = value.slice(0, at);
  const domain = value.slice(at + 1).toLowerCase();
  if (!domain || PROVIDERS.includes(domain) || ALSO_REAL.has(domain)) return null;
  let best = null;
  PROVIDERS.forEach((p) => {
    const dist = distance(domain, p);
    if (dist <= 2 && (!best || dist < best.dist)) best = { p, dist };
  });
  return best ? `${local}@${best.p}` : null;
};
